import httpClient from './httpClient';

class UsersService {
  // Get all users with filters and pagination
  async getUsers(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      
      // Add search parameter
      if (params.search) {
        queryParams.append('search', params.search);
      }
      
      // Add city_id parameter
      if (params.city_id) {
        queryParams.append('city_id', params.city_id);
      }
      
      // Add gender parameter
      if (params.gender) {
        queryParams.append('gender', params.gender);
      }
      
      // Add role parameter
      if (params.role) {
        queryParams.append('role', params.role);
      }
      
      // Add language parameter
      if (params.lang) {
        queryParams.append('lang', params.lang);
      }
      
      // Add pagination parameters
      if (params.per_page) {
        queryParams.append('per_page', params.per_page);
      }
      
      if (params.page) {
        queryParams.append('page', params.page);
      }
      
      const queryString = queryParams.toString();
      const url = `/api/admin/users${queryString ? `?${queryString}` : ''}`;
      
      console.log('UsersService: Making request to', url);
      const response = await httpClient.get(url);
      console.log('UsersService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('UsersService: Error in getUsers:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب المستخدمين'
      };
    }
  }

  // Get user by ID
  async getUserById(id) {
    try {
      console.log('UsersService: Making request to get user by ID:', id);
      const response = await httpClient.get(`/api/admin/users/${id}`);
      console.log('UsersService: Raw response from httpClient:', response.data);
      
      return response;
    } catch (error) {
      console.error('UsersService: Error in getUserById:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء جلب بيانات المستخدم'
      };
    }
  }

  // Create new user
  async createUser(userData) {
    try {
      console.log('UsersService: Creating new user:', userData);
      const response = await httpClient.post('/api/admin/users', userData);
      console.log('UsersService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('UsersService: Error in createUser:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء إنشاء المستخدم'
      };
    }
  }

  // Update user
  async updateUser(id, userData) {
    try {
      console.log('UsersService: Updating user:', id, userData);
      const response = await httpClient.post(`/api/admin/users/${id}`, userData);
      console.log('UsersService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('UsersService: Error in updateUser:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء تحديث المستخدم'
      };
    }
  }

  // Delete user
  async deleteUser(id) {
    try {
      console.log('UsersService: Deleting user:', id);
      const response = await httpClient.delete(`/api/admin/users/${id}`);
      console.log('UsersService: Raw response from httpClient:', response);
      
      return response;
    } catch (error) {
      console.error('UsersService: Error in deleteUser:', error);
      return {
        success: false,
        data: null,
        message: 'حدث خطأ أثناء حذف المستخدم'
      };
    }
  }
}

export default new UsersService();

